import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Table,
  Tabs
} from "antd";
import { ColumnProps } from "antd/lib/table";
import React, { useEffect, useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { ProdlogService } from "@gtpl/shared-services/production";
import { QaqcAnalysisService } from "@gtpl/shared-services/raw-material-procurement";
import { ProductService } from "@gtpl/shared-services/masters";

const { TabPane } = Tabs;

export const SPSAOperationView = () => {
  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<any>(null);

  const [operationData, setOperationData] = useState<any[]>([]);
  const [productionData, setProductionData] = useState<any[]>([]);
  const [productsData, setProductsData] = useState<any[]>([]);
  const [lotNumDropdownData, setLotNumDropdownData] = useState<any[]>([]);
  const [tabName, setTabName] = useState<string>("");
  const [allOperations, setAllOperations] = useState<any[]>([]);
  const prodLogService = new ProdlogService();
  const qaqcService = new QaqcAnalysisService();
  const productService = new ProductService();
  const { Option } = Select;
  const [filterForm] = Form.useForm();
  useEffect(() => {
    getOperationsForProdView(true);
    getAllProducts();
    getLotsDropdownForQAQC();
  }, []);

  const getOperationsForProdView = (isInitial?: boolean) => {
    const req: any = {};
    const operationreq  : any ={}
   
    if (
      filterForm.getFieldValue('operation') &&
      filterForm.getFieldValue('operation').length > 0
    ) {
      operationreq.operation = filterForm.getFieldValue('operation');
    }
    prodLogService.getOperationsForProdView(operationreq).then((res) => {
      if (res.status && res.data.length > 0) {
        if (isInitial) {
          setAllOperations(res.data);
        }
        const operations = res.data.map((o: any) => o.operation);
        setOperationData(operations);
        const firstOp = operations[0]
setTabName(firstOp);
         if (filterForm.getFieldValue('variant')) {
      req.product = filterForm.getFieldValue('variant');
    }

    if (filterForm.getFieldValue('lotNo')) {
      req.lotNumber = filterForm.getFieldValue('lotNo');
    }
    req.operation = [firstOp];
        
        getProdOpViewData(req);
      } else {
        if (isInitial) setAllOperations([]);
        setOperationData([]);
      }
    });
  };

  const getProdOpViewData = (req: any) => {
    prodLogService.getProdOpViewData(req).then((res) => {
      if (res.status) {
        setProductionData(res.data || []);
      } else {
        setProductionData([]);
      }
    });
  };

  const getAllProducts = () => {
    productService.getAllActiveProducts().then(res => {
      if (res.status) setProductsData(res.data);
      else setProductsData([]);
    });
  };

  const getLotsDropdownForQAQC = () => {
    qaqcService.getLotsDropdownForQAQC().then(res => {
      if (res.status) setLotNumDropdownData(res.data);
      else setLotNumDropdownData([]);
    });
  };

 const onTabChange = (val: string) => {
  setTabName(val);

  const req: any = {};

  if (filterForm.getFieldValue('variant')) {
    req.product = filterForm.getFieldValue('variant');
  }

  if (filterForm.getFieldValue('lotNo')) {
    req.lotNumber = filterForm.getFieldValue('lotNo');
  }

  req.operation = [val];

  getProdOpViewData(req);
};

  const onReset = () => {
    filterForm.resetFields();
    getOperationsForProdView(true);
  };

  function handleSearch(selectedKeys: any, confirm: any, dataIndex: any) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters: any) {
    clearFilters();
    setSearchText("");
  }

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    render: (text: any) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

  const columns: ColumnProps<any>[] = [
    {
      title: "S No",
      key: "sno",
      width: "70px",
      render: (text, object, index) => (page - 1) * 10 + (index + 1),
    },
    {
      title: "Operation",
      dataIndex: "operation",
      sorter: (a, b) => (a.operation || '').localeCompare(b.operation || ''),
      
      ...getColumnSearchProps("operation"),
    },
    {
      title: "Previous Operation",
      dataIndex: "prevOp",
            sorter: (a, b) => (a.prevOp || '').localeCompare(b.prevOp || ''),

      ...getColumnSearchProps("prevOp"),
    },
    {
      title: "Lot No",
      dataIndex: "lotNo",
        sorter: (a, b) => (a.lotNo || '').localeCompare(b.lotNo || ''),
      ...getColumnSearchProps("lotNo"),
    },
    {
      title: "Input Product",
      dataIndex: "productName",
      sorter: (a, b) => (a.productName || '').localeCompare(b.productName || ''),
      ...getColumnSearchProps("productName"),
    },
    {
      title: "Input Count Type",
      dataIndex: "inCountType",
      ...getColumnSearchProps("inCountType"),
      render: (text) => text ? text :'-'
    },
    {
      title: "Input Count ",
      dataIndex: "inputCountName",
      sorter: (a, b) => (a.inputCountName || '').localeCompare(b.inputCountName || ''),
      ...getColumnSearchProps("inputCountName"),
      render: (text) => text ? text :'-'
    },
    {
      title: "Out Product",
      dataIndex: "outVariantName",
      sorter: (a, b) => (a.outVariantName || '').localeCompare(b.outVariantName || ''),
      ...getColumnSearchProps("outVariantName"),
      render: (text) => text ? text :'-'
    },
    {
      title: "Output Count Type",
      dataIndex: "outCountType",
      ...getColumnSearchProps("outCountType"),
      render: (text) => text ? text :'-'
    },
    {
      title: "Output Count ",
      dataIndex: "outputCountName",
      ...getColumnSearchProps("outputCountName"),
      render: (text) => text ? text :'-'
    },
    {
      title: "Input Qty",
      dataIndex: "inputQty",
      render: (value) => Number(Number(value).toFixed(2))    },
    {
      title: "Output Qty",
      dataIndex: "outPutQty",
      render: (value) => Number(Number(value).toFixed(2))    },

    {
      title: "Yield %",
      dataIndex: "yieldPer",
      sorter: (a, b) => Number(a?.yieldPer || 0) - Number(b?.yieldPer || 0),
      ...getColumnSearchProps("yieldPer"),
      
    },

  ];

  return (
    <Card
      title={<span style={{ color: "white" }}>Operations View</span>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form form={filterForm} onFinish={() => getOperationsForProdView()} layout="inline" style={{ marginBottom: 16 }}>
        <Row gutter={16} style={{ width: '100%' }}>
          <Col xs={{ span: 8 }} sm={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
            <Form.Item
              label="Operation"
              name="operation"
              
            >
              <Select
                showSearch
                mode="multiple"
                placeholder="Select Operation"
                optionFilterProp="children"
                allowClear
              >
                {
                  allOperations.map(e => {
                    return (
                      <Option key={e.operation} value={e.operation}>{e.operation}</Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="lotNo" label="Lot No">
              <Select
                allowClear
                showSearch
                placeholder="Select Lot No"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {lotNumDropdownData.map(l => (
                  <Option key={l.lotNumber} value={l.lotNumber}>
                    {l.lotNumber}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="variant" label="Input Product">
              <Select
                allowClear
                showSearch
                placeholder="Select Input Product"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {productsData.map(p => (
                  <Option key={p.productId} value={p.productId}>
                    {p.productName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          

          <Col style={{ textAlign: 'right', paddingTop: '0px' }}>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
      {operationData.length > 0 && (
        <Tabs
          activeKey={tabName}
          onChange={onTabChange}
          type="card"
          size="large"
          tabBarStyle={{ fontWeight: 600 }}
        >
          {operationData.map((op) => (
            <TabPane
              key={op}
              tab={
                <span style={{ color: "#1890ff", fontWeight: 600 }}>
                  {op}
                </span>
              }
            >
              <Table
                columns={columns}
                dataSource={productionData.filter((item: any) => item.operation === op)}
                rowKey={(r) =>
                  `${r.lotNo}-${r.outVariantId}-${Math.random()}`
                }
                pagination={{
                  onChange: (p) => setPage(p),
                }}
                bordered
                size="middle"
              />
            </TabPane>
          ))}
        </Tabs>
      )}
    </Card>
  );
};

export default SPSAOperationView;